import { ApiPath } from "enums";
import { Get } from "utils";

export const getPremiumPayout = async ({ ...query }) => {
  const res = await Get(`${ApiPath?.PremiumPayout}`, query);
  return res.data;
};

export const getPremiumPayoutById = async ({ id, ...query }) => {
    const res = await Get(`${ApiPath.PremiumPayout}/${id}`, query);
    return res.data;
  };